export function useCharacterAge(birthday, currentDate) {
    if (birthday === undefined || currentDate === undefined) {
        return undefined;
    }
    const yearDiff = currentDate.year - birthday.year;
    const hasHadBirthdayThisYear = currentDate.day >= birthday.day;
    return hasHadBirthdayThisYear ? yearDiff : yearDiff - 1;
}
//# sourceMappingURL=useCharacterAge.js.map